import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['carousel', 'counter', 'thumbnail', 'description']

  connect() {
    if (!this.hasCarouselTarget) return

    this.boundUpdateCounter = this.updateCounter.bind(this)
    this.carouselTarget.addEventListener(
      'slid.bs.carousel',
      this.boundUpdateCounter
    )
  }

  disconnect() {
    if (this.hasCarouselTarget && this.boundUpdateCounter) {
      this.carouselTarget.removeEventListener(
        'slid.bs.carousel',
        this.boundUpdateCounter
      )
    }
  }

  updateCounter() {
    const items = this.carouselTarget.querySelectorAll('.carousel-item')
    const activeIndex = Array.from(items).findIndex((item) =>
      item.classList.contains('active')
    )

    // Update counter text
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${activeIndex + 1}/${items.length}`
    }

    // Update thumbnail borders
    if (this.hasThumbnailTarget) {
      this.thumbnailTargets.forEach((thumbnail, index) => {
        if (index === activeIndex) {
          thumbnail.classList.add('border-primary', 'border-3')
          thumbnail.classList.remove('border-secondary')
        } else {
          thumbnail.classList.remove('border-primary', 'border-3')
          thumbnail.classList.add('border-secondary')
        }
      })
    }

    // Update description visibility
    if (this.hasDescriptionTarget) {
      this.descriptionTargets.forEach((description, index) => {
        if (index === activeIndex) {
          description.classList.remove('d-none')
        } else {
          description.classList.add('d-none')
        }
      })
    }
  }
}
